module.exports = __webpack_public_path__ + "img/fcb-logo-tw.fee9d25a.png";